module.exports = __webpack_public_path__ + "img/church-in-the-oaks.1dcbdfae.svg";